import { FC, CSSProperties } from 'react'
import {
  DropDownList,
  DropDownListChangeEvent,
  DropDownsPopupSettings
} from '@progress/kendo-react-dropdowns'

import {
  FiscalYearDropDownList,
  FiscalYearDropDownListProps
} from './FiscalYearDropDownList'

const MONTHS: Array<string | number> = ['', 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]

export interface FiscalMonthDropDownListProps
  extends FiscalYearDropDownListProps {
  noDiv?: boolean
  /** FiscalMonthDropDownList style */
  fmddlStyle?: CSSProperties
  /** Month default value */
  fmddlDefaultValue?: number
  /** Month value */
  fmddlValue?: number
  onMonthChange?: (month: number) => void
  popupSettings?: DropDownsPopupSettings
  clear?: boolean
  fmTitle?: string
  fmClassName?: string
}

export const FiscalMonthDropDownList: FC<FiscalMonthDropDownListProps> = ({
  noDiv = false,
  fmddlStyle,
  fmddlDefaultValue,
  fmddlValue,
  onMonthChange,
  popupSettings,
  clear = false,
  fmTitle,
  fmClassName,
  ...restProps
}) => {
  const createValue = (fmddlValue?: number) => {
    return fmddlValue === undefined ? null : fmddlValue
  }

  const handleChange = (event: DropDownListChangeEvent) => {
    onMonthChange?.(event.value)
  }
  if (!clear && typeof MONTHS[0] === 'string') {
    MONTHS.shift()
  }

  return noDiv
    ? (
    <>
      <FiscalYearDropDownList popupSettings={popupSettings} clear={clear} {...restProps} />
      <DropDownList
        disabled={restProps.disabled}
        style={fmddlStyle}
        data={clear ? ['', ...MONTHS] : MONTHS}
        defaultValue={createValue(fmddlDefaultValue)}
        value={createValue(fmddlValue)}
        onChange={handleChange}
        popupSettings={popupSettings}
        title={fmTitle}
        className={fmClassName}
      />
    </>
      )
    : (
    <div style={{ display: 'flex' }}>
      <FiscalYearDropDownList popupSettings={popupSettings} clear={clear} {...restProps} />
      <DropDownList
        disabled={restProps.disabled}
        style={fmddlStyle}
        data={clear ? ['', ...MONTHS] : MONTHS}
        defaultValue={createValue(fmddlDefaultValue)}
        value={createValue(fmddlValue)}
        onChange={handleChange}
        popupSettings={popupSettings}
        title={fmTitle}
        className={fmClassName}
      />
    </div>
      )
}
